import React, { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import { ContainerDiv } from "../../components";
import { BreederDashboard } from "../breeder/dashboard";
import { GrowerDashboard } from "../grower/dashboard";

const Dashboard = () => {
  const { userData } = useContext(UserContext);

  return (
    <>
      <ContainerDiv>
        {userData?.organization.is_breeder ? (
          <BreederDashboard />
        ) : (
          <GrowerDashboard />
        )}
      </ContainerDiv>
    </>
  );
};

export default Dashboard;
